module.exports = __webpack_public_path__ + "img/s7Model3B.26db5504.webp";